import React from "react";
import styles from "./Counter.module.scss";
// https://www.npmjs.com/package/react-countup
import CountUp from "react-countup";

interface CounterItemProps {
    title: string,
    count: number,
}

const CounterItem: React.FC<CounterItemProps> = (
    {
        title,
        count
    }) => {
    return (
        <div className={styles.counterItem}>
            <p className={styles.counterItemTitle}>{title}</p>
            <CountUp className={styles.counterItemCount} end={count} separator=" " duration={2.75} suffix="+"/>
        </div>
    )
}

export default CounterItem;